var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c(
      "form",
      {
        staticClass: "m-form m-form--state",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.submitForm.apply(null, arguments)
          }
        }
      },
      [
        _c("div", { staticClass: "modal-body" }, [
          _c("div", { staticClass: "m-portlet__body" }, [
            _c("div", { staticClass: "form-group m-form__group row" }, [
              _c(
                "div",
                {
                  class: [
                    { "has-danger": _vm.errors.has("manu_name") },
                    "col-lg-4"
                  ]
                },
                [
                  _c("label", { attrs: { for: "name" } }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("capitalize")(_vm._f("translate")("manu_name"))
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.manufacturer_name,
                        expression: "manufacturer_name"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    ref: "manu_name",
                    staticClass: "form-control m-input",
                    attrs: {
                      type: "text",
                      id: "manu_name",
                      name: "manu_name",
                      placeholder: _vm._f("capitalize")(
                        _vm._f("translate")("enter_manu_name")
                      )
                    },
                    domProps: { value: _vm.manufacturer_name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.manufacturer_name = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("manu_name"),
                          expression: "errors.has('manu_name')"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [_vm._v(" " + _vm._s(_vm.errors.first("manu_name")) + " ")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: [
                    { "has-danger": _vm.errors.has("structure") },
                    "col-lg-8"
                  ]
                },
                [
                  _c("label", { attrs: { for: "name" } }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("capitalize")(_vm._f("translate")("structure"))
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.send_structure,
                        expression: "send_structure"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    ref: "structure",
                    staticClass: "form-control m-input",
                    attrs: {
                      type: "text",
                      id: "structure",
                      name: "structure",
                      placeholder: _vm._f("capitalize")(
                        _vm._f("translate")("enter_structure")
                      )
                    },
                    domProps: { value: _vm.send_structure },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.send_structure = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("structure"),
                          expression: "errors.has('structure')"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [_vm._v(" " + _vm._s(_vm.errors.first("structure")) + " ")]
                  )
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-footer" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-secondary",
              attrs: {
                type: "button",
                "data-dismiss": "modal",
                id: "btn-cancel-approve-manufacturer"
              },
              on: {
                click: function($event) {
                  return _vm.reset()
                }
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("capitalize")(_vm._f("translate")("close"))) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { type: "submit" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.submitForm.apply(null, arguments)
                }
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("capitalize")(_vm._f("translate")("save"))) +
                  "\n      "
              )
            ]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06322778", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06322778","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/cameras/NewManufacturer.vue
// module id = 435
// module chunks = 0 1 61 168